import React from 'react';
import { Link } from "react-router-dom";
import { analytics } from './AnalyticsManager';
import ChangelogModal from '../Popups/ChangelogModal';
import VersionTracker from '../../utils/VersionTracker';
import '../../css/changelog.css';

function Footer( props )
{
  const [ showChangelog, setShowChangelog ] = React.useState( false );
  const currentVersion = VersionTracker.getCurrentVersion();
  const displayVersion = VersionTracker.getDisplayVersion();

  // Note: Automatic changelog display is now handled at the App level
  // This only handles manual version clicks

  const handleVersionClick = () =>
  {
    analytics.track( 'version_number_clicked', {
      version: currentVersion
    } );
    setShowChangelog( true );
  };

  const handleCloseChangelog = () =>
  {
    setShowChangelog( false );
  };
  return (

    <div className="footer colour-dark-shade">
      <div className="footer-version-number" onClick={ handleVersionClick } title="Click to view changelog">
        v{ displayVersion }
      </div>

      <div className="footer-page-links">

        {/* © { new Date().getFullYear() } TileFolk.io */ }
        <Link
          to="/"
          className="text-blue-600 hover:text-blue-800 underline"
        >
          Lobby
        </Link>

        <Link
          to="/about"
          className="text-blue-600 hover:text-blue-800 underline"
        >
          About
        </Link>

        <Link
          to="/rules"
          className="text-blue-600 hover:text-blue-800 underline"
        >
          Rules
        </Link>

        <Link
          to="/faq"
          className="text-blue-600 hover:text-blue-800 underline"
        >
          FAQ
        </Link>

        <Link
          to="/privacy"
          className="text-blue-600 hover:text-blue-800 underline"
        >
          Privacy Policy
        </Link>
      </div>

      <div className="footer-social-links">

        <a href="https://www.buymeacoffee.com/fenderrio" target="_blank" rel="noopener noreferrer">
          <img
            src={ process.env.PUBLIC_URL + '/meeples-buy-me-a-coffee-button.png' }
            alt="Buy Me A Coffee"
            className="footer-buy-me-coffee-link"
          />
        </a>

        <img className="footer-social-link-icon" src={ process.env.PUBLIC_URL + '/ui/social-icon-discord.png' } alt="Discord Icon"
          onClick={ () =>
          {
            analytics.track( 'socialButton_Discord' );
            window.open( 'https://discord.gg/9qg5E8fCQQ', '_blank' ).focus();
          } } />

      </div>

      <ChangelogModal
        show={ showChangelog }
        version={ currentVersion }
        onClose={ handleCloseChangelog }
      />
    </div>

  );
}
export default Footer;
